import { render } from "./DynamicAppointmentFlow.vue?vue&type=template&id=965a62e6&scoped=true&ts=true"
import script from "./DynamicAppointmentFlow.vue?vue&type=script&lang=ts"
export * from "./DynamicAppointmentFlow.vue?vue&type=script&lang=ts"

import "./DynamicAppointmentFlow.vue?vue&type=style&index=0&id=965a62e6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-965a62e6"]])

export default __exports__